module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1503-49e460503cd9806828e3fc15235196d3.png";